import { useNavigate, useSearchParams } from "react-router-dom";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "./Invoice.module.css";
import { useAuth } from "../../components/context/Auth";
import { useEffect, useState } from "react";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import fetchData from "../../APIsControll/apiControll";
import { socket, SocketConnected } from "../../Socket/socket";
import { getStatusColor } from "../../Utils/Utils";

const Uploadinvoice = () => {
  const navigate = useNavigate();
  const { mode, managerId, designation } = useAuth();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const getInvoices = async () => {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
      };
      try {
        setLoading(true);
        const data = await fetchData("invoice/getInvoicePdf", apiData);
        if (data.status === "success") {
          setData(data.data);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    if (managerId) {
      getInvoices();
    }
  }, [managerId, orderId]);

  useEffect(() => {
    SocketConnected({
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: JSON.parse(localStorage.getItem("warehouse")),
    });
    socket.on("updateInvoiceData", (updateInvoiceData) => {
      console.log("socket", updateInvoiceData);
      setData(updateInvoiceData?.allInvoiceData?.reverse());
    });
    return () => {
      socket.disconnect();
    };
  }, [designation, managerId]);

  const header = [
    "File",
    "Date",
    "Order ID",
    "Amount",
    "Status",
    "Type",
    "Last Action",
  ];

  return (
    <div
      className={styles.inv}
      style={{
        backgroundColor: mode && "#2C2E33",
        borderColor: mode && "#2C2E33",
      }}
    >
      <div className={styles.inv_top}>
        <div className={styles.inv_top_left}>
          <TopTabBar truncate={false} text={`Uploaded Invoices / ${orderId}`} />
        </div>
      </div>

      <ul className={styles.data}>
        <li
          className={`${styles.data_header} ${styles.grid} ${
            mode ? styles.data_header_dark : ""
          }`}
        >
          {header.map((h, index) => (
            <div className={styles.entry_2} key={`${h}-${index}`}>
              {h}
            </div>
          ))}
        </li>

        <div className={styles.data_list}>
          {loading ? (
            <div>
              <Skeleton
                lines={15}
                thickness={5}
                additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
              />
            </div>
          ) : (
            <>
              {!loading && data.length === 0 ? (
                <>
                  <div className={styles.no_data}>
                    <NoDataFound
                      icon={<TemplateNotFound />}
                      textTitle={`No Data Found`}
                    />
                  </div>
                </>
              ) : (
                <>
                  {data.map((r) => (
                    <div key={r.orderId}>
                      <li
                        className={`${styles.data_row} ${styles.grid} ${
                          mode ? styles.data_row_dark : ""
                        }`}
                        onClick={() => {
                          navigate("/invoices/viewpdf?pdf=" + r.invoice);
                        }}
                      >
                        <div
                          className={styles.entry_2}
                          title={r.invoice.split("/").pop()}
                        >
                          {r.invoice.split("/").pop()}
                        </div>
                        <div className={styles.entry_2} title={r.invoiceDate}>
                          {r.invoiceDate}
                        </div>
                        <div className={styles.entry_2} title={r.orderId}>
                          {r.orderId}
                        </div>
                        <div className={styles.entry_2} title={r.amount}>
                          {r.amount}
                        </div>
                        <div
                          className={styles.entry_2}
                          style={{ color: getStatusColor(r.status) }}
                          title={r.status}
                        >
                          {r.status}
                        </div>
                        <div className={styles.entry_2} title={r.invoiceType}>
                          {r.invoiceType}
                        </div>
                        <div className={styles.entry_2} title={r.lastAction}>
                          {r.lastAction}
                        </div>
                      </li>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </ul>
    </div>
  );
};

export default Uploadinvoice;
